<!--实时需量-->
<template>
  <!-- <div class="demandRTCurveBody">
		<elCheckBoxTree slot="tree" :dataList='getDemanList' @checkItem="treeCheckItem"></elCheckBoxTree>
		<div class="pageBody" slot="body">
			<iconButton @buttonClick='downloadExcel' buttonText='导出' icoName="wedoButton/download.png"></iconButton>
			<div class="monreportRigth">
				<div class="infolist" style="height: calc(65% - .37rem);">
					<vchart style="width: 100%;height: 100%;" ref='vchart'></vchart>
				</div>
				
			</div>
		</div>
	</div> -->
  <div class="mydemandRTCurve">
    <div class="con">
      <div class="tree-left">
        <elUnitTree @checkFun='treeCheckItem' :dataList='getDemanList'></elUnitTree>
      </div>
      <div class="right-table">
        <div class="Files-top">
          <div class="ic-left">
            <span>实时需量</span>
          </div>
          <div class="btns">
            <el-button @click="downloadExcel" type="primary" class="last-el-button">导出</el-button>
          </div>
        </div>
        <div class="mychart" :style="{'height':heights+'px'}">
          <vchart style="width: 100%;height: 100%;" ref='vchart'></vchart>
        </div>
        <!-- <infoList ref="infoList" style="height: 2.5rem;" :columns='columns' :dataList="nowPage" :pageLen='pageLen'
				 :totalSize="dataList.length" @selectPage="nowIndex = $event" :fillAll="true"></infoList> -->
        <el-table :data="nowPage" :height="tabheights" border style="width: 100%;margin-top:20px">
          <el-table-column label="序号" width="90" align="center">
            <template slot="empty">
              <span class="noData">
                <img src="@/assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="devicename" label="设备名称" min-width="180"> </el-table-column>
          <el-table-column prop="variableName" label="变量名称" min-width="180"> </el-table-column>
          <el-table-column prop="value" label="实时值" min-width="90" align="right"> </el-table-column>

        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
  // import treeBody from '@/components/module/slotModule/treeBody.vue'
  // import iconButton from '@/components/module/universal/iconButton.vue'
  import vchart from '@/components/module/chart/vchart.vue'
  import infoList from '@/components/module/universal/infoList.vue'
  // import elCheckBoxTree from '@/components/module/tree/elCheckBoxTree.vue'
  import elUnitTree from '@/components/module/newTree/elUnitTree.vue'
  export default {
    components: {
      // treeBody,
      // iconButton,
      vchart,
      infoList,
      // elCheckBoxTree,
      elUnitTree
    },
    props: {},
    data () {
      return {
        heights: document.getElementById('app').clientHeight-470,
        tabheights: document.getElementById('app').clientHeight-700,
        nowIndex: 0,
        nowDeviceList: [],
        variableTreeResult: {},
        nowSeries: [],
        refreshInterval: 2000,
        columns: [{
          name: '设备名称',
          key: 'devicename'
        },{
          name: '变量名称',
          key: 'variableName'
        },{
          name: '实时值',
          key: 'value'
        }],
        from2name: {},
        demandTree: [],
        demandApptypeList: [264,265,266,267,268,269,270,271,272,273,274,275]
      }
    },
    created () {
      debugPage=this
    },
    mounted () {
      // return
      debugPage=this
      this.options=this.$refs.vchart.getDefaultOptions()
      this.options.title.text=""
      this.options.tooltip.formatter=(params,ticket,callback) => {
        var label=new Date(params[0].data[0]).formatByTime()+"</br>"
        params.forEach(item => {
          var values;
          if(isnull(item.data[1])) {
            values="无采集数据";
          } else {
            values=cutDigital(item.data[1]);
          }
          label+=item.seriesName+" : "+values+"</br>"
        })
        return label;
      }
      this.options.toolbox={
        show: true,
        showTitle: true, // 隐藏默认文字，否则两者位置会重叠
        top: '-5',
        right: "5",
        feature: {
          magicType: {
            type: ['line','bar','stack','tiled'],title: {
              line: '切换为折线图',
              bar: '切换为柱状图',
              stack: '切换为堆叠',
              tiled: '切换为平铺',
            }
          },

          saveAsImage: {
            show: true,
            title: '下载图片'
          },
          // dataView: { show: true, readOnly: true, lang: ['', '关闭'] },
        },


      },
        // this.options.toolbox.show = false
        this.options.dataZoom=[{
          type: 'slider',
          show: true,
          start: 0,
          end: 100,
          handleSize: 8
        },
        {
          type: 'inside',
          start: 0,
          end: 100
        }
        ]
      this.options.xAxis={
        type: 'time',
        splitLine: {
          show: true
        }
      }

      this.$refs.vchart.setData(this.options,true)
      addNewTask('refreshDemandRTCurve',2000,this.refreshInterval,-1,() => {
        this.addData()
      })
      this.loadDemandTree()
    },
    destroyed () {
      removeTask('refreshDemandRTCurve')
      this.realTimeValueStore.commit("removeKeys",this.nowVariableNameList)
    },
    computed: {
      getDemanList () {
        let tree=this.$store.deviceStore.getters.getDeman(this.nowUnit.id)
        let list=[]
        if(!isempty(tree)) {
          list=[deviceList(tree)]
        }
        return list;
      },
      getBackgroudImageStyle () {
        return this.$store.resourcesStore.getters.getBackgroudImageStyle
      },
      getResourcesByName () {
        return this.$store.resourcesStore.getters.getResourcesByName
      },
      getColorById () {
        return this.$store.resourcesStore.getters.getColorById
      },
      realTimeValueStore () {
        return this.$store.realTimeValueStore
      },
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit
      },
      nowVariableTree () {
        if(isempty(this.nowDeviceList)) {
          return []
        }
        var variableTreeArr=[]
        this.nowDeviceList.forEach(item => {
          var variableTree=this.$store.variableStore.getters.getVariableTree(item.no)
          variableTree.forEach(tree => {
            tree.devicename=item.name
          })
          variableTreeArr.push(variableTree)
        })
        var result=[]
        variableTreeArr.forEach(item => {
          result=result.concat(item)
        })
        return result
      },
      nowVariableList () {
        if(isempty(this.nowDeviceList)) {
          return []
        }
        // 当前要显示的变量列表
        var variableList=[]
        for(var i=0,len=this.nowVariableTree.length;i<len;i++) {
          var item=this.nowVariableTree[i]
          for(var i1=0,len1=item.next.length;i1<len1;i1++) {
            var item1=item.next[i1]
            item1.devicename=item.devicename
            if(this.demandApptypeList.includes(item1.typeNo)) {
              var newItem=copy(item1)
              newItem.name=newItem.name.subByFirstChar(".")
              variableList.push(newItem)
            }
          }
        }
        variableList.sort((a,b) => {
          return a.typeNo-b.typeNo
        })
        return variableList
      },
      nowVariableNameList () {
        this.from2name={}
        return this.nowVariableList.map(item => {
          this.$set(this.from2name,item.fromName,item.name)
          return item.fromName
        })
      },
      pageLen () {
        return this.dataList.length<20? this.dataList.length:20
      },
      nowPage () {
        // 按照页码来返回当前应该显示的列表
        var list=this.dataList.filter((item,index) => {
          return index>=this.nowIndex*this.pageLen&&index<(this.nowIndex+1)*this.pageLen
        })
        return list
      },
      dataList () {
        if(isempty(this.nowVariableNameList)) {
          return []
        }
        //获取实时值
        var vl=this.realTimeValueStore.getters.getValue(this.nowVariableNameList)
        var nameList=[]
        return this.nowVariableNameList.map((item,index) => {
          var value=vl[index]
          if(isNaN(parseFloat((value)))||isnull(parseFloat((value)))) {
            value="--"
          }
          var name=this.from2name[item]? this.from2name[item]:item

          var indexLabel=0
          nameList.forEach(i => {
            if(i==name) {
              indexLabel++
            }
          })
          nameList.push(name)
          if(indexLabel>0) {
            name=name+indexLabel
          }
          return {
            devicename: this.nowVariableList[index].fromName.split('.')[0],
            variableName: name,
            value
          }
        })
      },
    },
    watch: {
      nowVariableNameList (nv,ov) {
        this.realTimeValueStore.commit("removeKeys",ov)
        this.realTimeValueStore.commit("addKeys",nv)
        //重置缓存数据
        var list=[]
        var dataList=[]
        var now=new Date().getTime()
        for(var i=0;i<90;i++) {
          dataList.unshift([now-this.refreshInterval*i,undefined])
        }
        var valueList=dataList.map(item => {
          return item[1]
        })
        var sumData={}
        nv.forEach((item,index) => {
          var devicename=this.nowVariableList[index].fromName
          var typeName=this.from2name[item]? this.from2name[item]:item
          var name=devicename /*+ "_" + typeName*/
          list.push({
            name,
            type: 'line',
            smooth: true,
            symbol: 'emptyCircle',
            sampling: 'average',
            markPoint: {
              data: [{
                name: '最大值',
                type: 'max'
              }]
            },
            data: dataList.copy()
          })
        })
        this.nowSeries=list
        this.options.series=list
        var selected={}
        this.options.legend.data=
          nv.map((item,index) => {
            var devicename=this.nowVariableList[index].fromName
            var typeName=this.from2name[item]? this.from2name[item]:item
            var name=devicename+"_"+typeName
            if(index>5) {
              selected[name]=false
            }
            return {
              name: name,
              icon: 'roundRect'
            }
          })
        this.options.legend.selected=selected
        this.$refs.vchart.setData(this.options,true)
      },
      nowUnit (nv,ov) {
        this.loadDemandTree()
      }
    },
    methods: {
      downloadExcel () {
        this.$refs.infoList.downloadExcel('实时需量');
      },
      treeCheckItem (item) {
        this.nowDeviceList=item
        // item.forEach(list=>{
        // 	if(list.type=='virtualDevice'){
        // 		this.nowDeviceList.push(list)
        // 	}
        // })
      },
      loadDemandTree () {
        //查询需量设备树
        /*	this.$api.deviceApi.getReadDeviceTree(this.nowUnit.unitId, "264,265,266", respon => {
            var tree = findTreeItem([respon], item => {
            return item.unitid == this.nowUnit.id
          })
            this.demandTree = [deviceList(tree)]
          	
        	
          })*/
      },
      addData () {
        //增加新值
        if(isempty(this.nowVariableNameList)) {
          return
        }
        if(this.$refs.vchart==undefined) {
          return
        }
        var vl=this.realTimeValueStore.getters.getValue(this.nowVariableNameList)
        var now=Date.now()
        this.nowSeries.forEach((item,index) => {
          item.data.shift()
          var res=vl[index]
          if(isNaN(parseFloat((res)))||isnull(parseFloat((res)))) {
            res=undefined
          }
          item.data.push([now,res])
        })
        this.$refs.vchart.setData({
          series: this.nowSeries
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .mydemandRTCurve {
    .con {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      display: flex;

      .public-flex {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      // 正常
      .patrol {
        p {
          width: 8px;
          height: 8px;
          background-color: #0DAE88;
          border-radius: 50%;
          margin-right: 8px;
        }

        span {
          color: #0DAE88;
        }
      }

      // 非正常
      .rush {
        p {
          width: 8px;
          height: 8px;
          background-color: #FF1D1D;
          border-radius: 50%;
          margin-right: 8px;
        }

        span {
          color: #FF1D1D;
        }
      }

      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
      }

      .tree-left {
        width: 3rem;
        height: 100%;
        padding: 12px;
        box-sizing: border-box;
        background-color: #fff;
        margin-right: 8px;

        .btns {
          display: flex;
          // justify-content: space-evenly;
          margin-bottom: 8px;

          button {
            margin-right: 12px;
          }

          .el-button--mini {
            padding: 7px 10px !important;
          }

          .el-button+.el-button {
            margin-left: 0px;
          }
        }

        .search {
          display: flex;
          justify-content: center;
          margin-bottom: 12px;
        }

      }

      .right-table {
        width: calc(100% - 3.08rem);
        height: 100%;
        padding: 12px 20px 20px 20px;
        box-sizing: border-box;
        background-color: #fff;
        position: relative;

        .mycharts {
          display: flex;

          .charts-left {
            width: 35%;
          }

          .charts-right {
            width: 70%;
          }
        }
      }
    }
  }
</style>